<template>
    <div class="checkbox-wrapper dropdown" :class="disabled ? 'disabled':''">
        <label v-if="label" id="filterDropdownBtn" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">{{ label }}
            <span v-if="checked.length" class="selection-badge">{{ checked.length }}</span>
        </label>

        <div v-if="! disabled" class="dropdown-menu p-2">
            <div :class="'form-check ' + dimensionClass" v-for="item in items" :key="item.id">
                <input :id="internalName + '-' + item.id" class="form-check-input" type="checkbox" :name="name" :value="item.id" :checked="isChecked(item.id)"  @change="handleChange(item.id)"/>
                <label :for="internalName + '-' + item.id" class="form-check-label">
                    {{ item.name }}
                </label>
            </div>
            <div v-if="items.length == 0">
                <label>{{ this.forElseMessage }}</label>
            </div>
            <div class="invalid-feedback d-block" v-if="error">
                {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CheckboxInput",
    props: {
        name: { type: String, required: true },
        label: { type: String, default: '', required: false },
        items: { type: Array, default: () => [], required: false },
        checked: { type: Array, default: () => [], required: false },
        dimension: { type: String, default: 'horizontal', required: false },
        forElseMessage: { type: String, default: 'No items available', required: false },
        error: { type: String, default: '', required: false },
        disabled: { type:Boolean, default: false, required: false},
    },
    computed: {
        internalName() {
            return this.name.replace(/[\[\]]/g,"");
        },
        dimensionClass() {
            if(this.dimension == 'vertical') {

                return 'form-check-vertical';
            }

            return 'form-check-inline';
        }
    },
    methods: {
        isChecked(id) {

            return this.checked.includes(id);
        },
        handleChange(id) {
            if(this.isChecked(id)){
                this.checked.splice(this.checked.indexOf(id), 1)
            } else {
                this.checked.push(id);
            }

            this.$emit('input', this.checked);
        },
    }
}
</script>

<style scoped>
.checkbox-wrapper {
    min-height: calc(1.6em + 0.75rem + 2px);
    font-size: 0.9rem;
    font-weight: 400;
    line-height: 1.6;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
}
.checkbox-wrapper label {
    margin-bottom: 0;
    width: 100%;
}
.checkbox-wrapper label#filterDropdownBtn {
    padding: 0.375rem 0.75rem;
}
.dropdown-toggle::after {
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
}
.dropdown-menu {
    width: 100%;
}
.disabled {
    background-color: #e9ecef;
    opacity: 1;
    cursor: not-allowed;
}
.selection-badge {
    position: absolute;
    top: -6px;
    left: -9px;
    background-color: #76C893;
    color: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1;
}
</style>